if (!window.customElements.get("discount-card")) {
  var DiscountCopy = class extends HTMLElement {
    constructor() {
      super();
      this._copyButtonEl = this.querySelector("[data-copied]");
      this._codeContentEl = this.querySelector("[data-code]");
    }
    connectedCallback() {
      this._copyButtonEl.addEventListener("click", this._onCopyClick.bind(this));
    }
    disconnectedCallback() {
      this._copyButtonEl?.removeEventListener("click", this._onCopyClick.bind(this));
    }
    _onCopyClick(event) {
      const el = event.currentTarget;
      const dataSuccess = el.getAttribute("data-copied");
      if (dataSuccess == "false") {
        const text = this._codeContentEl.innerHTML;
        // copy
        try {
          navigator.clipboard.writeText(val).then(res => {
            resolve();
          }).catch(e => {
            reject(e);
          });
        } catch (error) {
          const input = document.createElement('input');
          input.setAttribute('readonly', 'readonly');
          input.setAttribute('value', text);
          document.body.appendChild(input);
          input.setSelectionRange(0, 9999);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        el.setAttribute("data-copied", "true");
        // hide success icon
        setTimeout(() => {
          el.setAttribute("data-copied", "false");
        }, 3000);
      }
    }
  };
  window.customElements.define("discount-copy", DiscountCopy);
}